import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { Button } from 'components/Button/Button';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const GraphNetworkViewerSubmitButton: FC = () => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    graphLoading: (s) => s.loading === 'LOADING',
    networkViewerTab: prop('sidePanel', 'networkViewerTabId'),
  });

  return (
    <div
      className={classNames(
        'graph-side-panel-main-submit-button',
        'graph-side-panel-main-submit-button--main-tab',
        'graph-side-panel-main-submit-button--with-separator',
      )}
    >
      <Button
        variant='primary'
        type='submit'
        disabled={ctxProps.graphLoading}
        className='w-44'
        size='sm'
      >
        {ctxProps.graphLoading && (
          <i className='fa-regular fa-spinner fa-spin fa-fw mr-lgu-2' />
        )}
        {msg.canvasGraph.graphSidePanel.networkViewerDataInput.btnSubmit}
      </Button>
    </div>
  );
};
